<script>
  export let title = 'About Curbza';
  export let leadPargraph = 'Curbza  is a peer-to-peer platform developer that specializes in digital marketplace creation for businesses, educational instituations, government, and non-profit organizations. The concept for Curbza was inspired by endless clutter. There needed to be a way to exhange assets across facilities owned by organizations.';
  export let blurbs = [
    {
      title: 'Mission',
      text: 'To connect organizations worldwide with peer-to-peer intelligent technology to facilitate exchange and transactions'
    },
    {
      title: 'Vision',
      text: 'Curbza\'s vision is to organize the world\'s assets across private peer-to-peer networks'
    },
  ];
</script>

<style>
  #about-us {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url('/assets/images/wallpapers/bg-about.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-color: var(--panel);
    color: var(--panel-text);
    margin-bottom: 0;
    padding: 0;
    font-size: 20px;
  }

  #about-us .lead-paragraph {
    font-size: 34px;
    text-align: center;
  }

  #about-us .row {
    align-items: flex-start;
    justify-content: center;
    height: 384px;
    z-index: 0;
  }

  #about-us .row:first-child {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 0 64px;
  }

  #about-us .row:first-child .burn {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--dark-alpha-8);
  }

  #about-us .row:first-child .title,
  #about-us .row:first-child .lead-paragraph {
    color: var(--light) !important;
    z-index: 1;
  }

  #about-us .row:first-child .lead-paragraph {
    text-align: center;
    font-size: 24px;
  }

  #about-us .row:last-child {
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2vw 64px;
    z-index: 0;
  }

  #about-us .row:last-child .dodge {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--light-alpha-8);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  #about-us .row .col {
    max-width: auto;
    text-align: center;
    z-index: 1;
  }

  #about-us .row .col .col-title {
    font-size: 48px;
  }

  #about-us .row .col:first-child {
    margin-right: 1vw;
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    #about-us .row {
      height: auto;
      padding: 4vw !important;
      flex-direction: column;
    }

    #about-us .row:last-child {
      flex-direction: column;
      align-items: center;
    }

    #about-us .row:first-child .lead-paragraph,
    #about-us .row:last-child .lead-paragraph {
      text-align: center;
    }

    #about-us .row .title,
    #about-us .row .col-title {
      font-size: xxx-large !important;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

    #about-us .row:first-child {
      padding: 0 64px;
    }

    #about-us .row:last-child {
      padding: 2vw 64px;
    }

    #about-us .row .col {
      max-width: 100%;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {

    #about-us .row:first-child {
      padding: 0 250px;
    }

    #about-us .row:last-child {
      padding: 2vw 250px;
    }

    #about-us .row {
      align-items: center;
    }
  }
</style>

<main id='about-us' class="section">
  <div class="row">
    <div class="burn"></div>
    <h1 class='title'>{title}</h1>
    <p class='lead-paragraph'>{@html leadPargraph}</p>
  </div>

  <div class="row">
    <div class="dodge"></div>
    {#each blurbs as blurb}
    <div class="col">
      <h3 class='col-title'>{blurb.title}</h3>
      <p class='col-text'>{blurb.text}</p>
    </div>
    {/each}
  </div>
</main>